import React, { useState, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { transformRegionToMap } from 'msp-components'
import { useMultiSite } from 'msp-integrations'
import { Header as HeaderComponent } from '@/components/organisms/Header'
import { HeaderMenuFlyout } from '@/components/organisms/HeaderMenuFlyout'
import { LoginFlyout } from '@/components/organisms/LoginFlyout'
import NotificationFlyout from '@/components/organisms/NotificationFlyout/NotificationFlyout'

type HeaderProps = {
  data: any
  regions: Array<any>
}

const Header = ({ regions }: HeaderProps) => {
  const { pathname } = useLocation()
  const { buildUrl } = useMultiSite()
  const history = useHistory()

  const [isMainMenuOpen, setIsMainMenuOpen] = useState<boolean>(false)
  const [isLoginFlyoutOpen, setIsLoginFlyoutOpen] = useState<boolean>(false)
  const [isNotificationFlyoutOpen, setIsNotificationFlyoutOpen] =
    useState<boolean>(false)

  useEffect(() => {
    closeMainMenuDrawer()
  }, [pathname])

  const openMainMenuDrawer = () => {
    setIsMainMenuOpen(true)
  }
  const closeMainMenuDrawer = () => {
    setIsMainMenuOpen(false)
  }

  const openLoginFlyout = () => {
    setIsLoginFlyoutOpen(true)
  }

  const closeLoginFlyout = () => {
    setIsLoginFlyoutOpen(false)
  }

  const openNotificationFlyout = () => {
    setIsNotificationFlyoutOpen(true)
  }

  const closeNotificationFlyout = () => {
    setIsNotificationFlyoutOpen(false)
  }

  const onLogoClick = () => {
    const path = buildUrl('/')
    history.push(path)
  }

  const areas = transformRegionToMap(regions)

  return (
    <>
      <HeaderComponent
        onMenuClick={openMainMenuDrawer}
        onUserClick={openLoginFlyout}
        onNotificationClick={openNotificationFlyout}
        onLogoClick={onLogoClick}
        regions={regions}
      />
      <HeaderMenuFlyout
        isOpen={isMainMenuOpen}
        onOpen={openMainMenuDrawer}
        onClose={closeMainMenuDrawer}
        areas={areas}
      />
      <LoginFlyout
        isOpen={isLoginFlyoutOpen}
        onOpen={openLoginFlyout}
        onClose={closeLoginFlyout}
      />
      <NotificationFlyout
        isOpen={isNotificationFlyoutOpen}
        onOpen={openNotificationFlyout}
        onClose={closeNotificationFlyout}
      />
    </>
  )
}

export default Header
